import { useContext } from 'react';

import { UniversalLoaderContext } from '../UniversalLoader';

export const useUniversalLoader = () => {
  return useContext(UniversalLoaderContext);
};
